import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';
import PromptList from './PromptList';
import Prompt from './Prompt';

const Prompts = () => {
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [prompts, setPrompts] = useState([]);

  useEffect(() => {
    const fetchPrompts = async () => {
      try {
        const promptsRef = collection(db, 'prompts');
        const q = query(promptsRef, orderBy('type', 'desc'), orderBy('name'));
        const querySnapshot = await getDocs(q);
        const promptsData = [];
        querySnapshot.forEach((doc) => {
          promptsData.push({ id: doc.id, ...doc.data() });
        });
        setPrompts(promptsData);
        if (promptsData.length > 0) {
          setSelectedPrompt(promptsData[0]);
        }
      } catch (error) {
        console.error("Error al obtener los prompts:", error);
      }
    };

    fetchPrompts();
  }, []);

  const handleSelectOption = (ref) => {
    setSelectedPrompt(ref);
  };

  return (
    <div className="flex h-[80vh] bg-gray-20 overflow-hidden">
      {/* Sidebar with Options List */}
      <div className="sticky top-0 w-64 h-[80vh] bg-gray-100 p-4 border-r overflow-y-auto"> 
        <PromptList
          prompts={prompts}
          onSelectPrompt={handleSelectOption}
          selectedPrompt={selectedPrompt}
        />
      </div>

      {/* Main Area */}
      <div className="flex-grow flex flex-col overflow-hidden">
        <div className="flex-grow flex justify-center items-center p-6">
          <div className="w-full max-w-4xl h-full flex flex-col items-center">
            <Prompt selectedPrompt={selectedPrompt} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prompts;
